import { ScriptAnswerInput } from '@vette/data-access';

export enum FormItemNames {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  phone = 'phone',
  interviewInSpanish = 'interviewInSpanish',
  location = 'location',
  knockoutAnswers = 'knockoutAnswers',
  zipCode = 'zipCode',
}

export type FormType = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  interviewInSpanish: string;
  location: string;
  knockoutAnswers: ScriptAnswerInput[];
  zipCode?: string;
};
